var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 18.8333H20.0083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 13V15.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3334 24.2501V11.7501C13.3334 11.1975 13.5529 10.6676 13.9436 10.2769C14.3343 9.88624 14.8642 9.66675 15.4167 9.66675H25.8334C26.0544 9.66675 26.2663 9.75455 26.4226 9.91083C26.5789 10.0671 26.6667 10.2791 26.6667 10.5001V25.5001C26.6667 25.7211 26.5789 25.9331 26.4226 26.0893C26.2663 26.2456 26.0544 26.3334 25.8334 26.3334H15.4167C14.8642 26.3334 14.3343 26.1139 13.9436 25.7232C13.5529 25.3325 13.3334 24.8026 13.3334 24.2501ZM13.3334 24.2501C13.3334 23.6975 13.5529 23.1676 13.9436 22.7769C14.3343 22.3862 14.8642 22.1667 15.4167 22.1667H26.6667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav4);
export default __webpack_public_path__ + "static/media/sidebar-nav-4.f715241522fe3e102892c7dc59c92d49.svg";
export { ForwardRef as ReactComponent };